/**
 * TrendModa - Canlı İzleyici Simülasyonu
 * Deterministik pseudo-random, 30 saniyede bir güncelleme
 */
(function () {
  'use strict';

  function initLiveViewers() {
    var containers = document.querySelectorAll('.live-viewers');
    if (!containers.length) return;

    containers.forEach(function (el) {
      var productId = parseInt(el.dataset.productId || '0', 10);
      var min = parseInt(el.dataset.min || '15', 10);
      var max = parseInt(el.dataset.max || '80', 10);
      var countEl = el.querySelector('.live-viewers__count');
      if (!countEl) return;

      function getViewerCount(seed) {
        var range = max - min;
        var hash = Math.abs(((seed * 2654435761) >>> 0) % range);
        return min + hash;
      }

      var seed = productId + Math.floor(Date.now() / 30000);
      var current = getViewerCount(seed);
      countEl.textContent = current;

      function randMs(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }

      function tick() {
        var delta = Math.floor(Math.random() * 7) - 3; // -3 … +3
        current = Math.max(min, Math.min(max, current + delta));
        countEl.textContent = current;
        setTimeout(tick, randMs(8000, 18000));
      }
      setTimeout(tick, randMs(8000, 18000));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLiveViewers);
  } else {
    initLiveViewers();
  }
})();
